import { SagaIterator } from 'redux-saga';
import { takeLatest } from 'redux-saga/effects';
import { workerGetCounteragentsList, workerGetOrdList } from './workers';
import { getCounteragentsList, getOrdList } from '../actions';

export default function* watchCounteragents(): SagaIterator {
  yield takeLatest(getCounteragentsList, workerGetCounteragentsList);
  yield takeLatest(getOrdList, workerGetOrdList);
}
